import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <section className="footer">
      <p>
        <span>
          <a
            href="https://github.com/apease-9/react-dictionary"
            target="_blank"
            rel="noreferrer noopener"
          >
            Open-source code
          </a>{" "}
          by Alia Pease
        </span>
        <br />
        <span id="wordData">
          Dictionary API Providers:{" "}
          <a
            href="https://www.wordnik.com/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Wordnik
          </a>{" "}
          and{" "}
          <a
            href="https://dictionaryapi.dev/"
            target="_blank"
            rel="noreferrer noopener"
          >
            (unofficial) Google Dictionary API
          </a>
        </span>
        <br />
        <span>
          Photos Provider:{" "}
          <a
            href="https://www.pexels.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            Pexels
          </a>
        </span>
      </p>
    </section>
  );
}
